import React, { createContext, useState } from "react";
import PropTypes from "prop-types";

export const BusinessCategoryContext = createContext();

export const BusinessCategoryContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <BusinessCategoryContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
      }}
    >
      {children}
    </BusinessCategoryContext.Provider>
  );
};

export default BusinessCategoryContextProvider;
BusinessCategoryContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
